module.exports = __webpack_public_path__ + "static/media/ajax-Loader.63f6c6e3.gif";